module.exports = __webpack_public_path__ + "static/media/music_instructor_saxophone_private_lessons.fc17c12f.jpeg";